import React from "react";
import "./SelectableTags.scss";

import classNames from "classnames";

import { ReactComponent as PlusIcon } from "src/images/plus-transparent.svg";
import { ReactComponent as CrossIcon } from "src/images/close-alt.svg";

interface Props {
  feed: string[];
  value: string[];
  onChange: (value: string[]) => void;
  displayWithoutWrapper?: boolean;
}

const SelectableTags = ({
  feed,
  value,
  onChange,
  displayWithoutWrapper,
}: Props) => {
  const toggleKeyword = (keyword: string) => {
    if (value.includes(keyword)) {
      onChange(value.filter((item) => item !== keyword));
    } else {
      onChange([...value, keyword]);
    }
  };

  const content = feed?.map((keyword) => {
    const isActive = value.includes(keyword);

    return (
      <span
        key={keyword}
        className={classNames("selectable-tag", {
          "selectable-tag--active": isActive,
        })}
        onClick={() => toggleKeyword(keyword)}
      >
        {keyword}
        {isActive ? <CrossIcon /> : <PlusIcon />}
      </span>
    );
  });

  if (displayWithoutWrapper) {
    return <>{content}</>;
  }

  return <div className="selectable-tags">{content}</div>;
};

export default SelectableTags;
